<div class="content-seguridad">
  <app-boton-volver (clickVolver)="goBack()"></app-boton-volver>
  <!-- secciones-->
  <div class="component-seguridad">
    <div class="title-section title">Solicitud de pensión por vejez</div>
    <router-outlet></router-outlet>
  </div>
</div>